import { IconBase, IconComponent } from './BaseIcon';

export const Leaf: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M17.73.79a2.67 2.67 0 0 0-3.8.02C7.8 7.13 1.21 16.36 4.6 24.4A13.2 13.2 0 0 0 15.85 32a13.48 13.48 0 0 0 11.57-7.84c2.67-6.41-.6-14.28-9.69-23.37Zm-3.21 3.3v10.82l-1.62-1.58a1.33 1.33 0 1 0-1.89 1.88l3.5 3.46v4.9l-4.35-4.34a1.33 1.33 0 1 0-1.9 1.88l6.26 6.25v1.84c-5.32-1.1-15.35-8.33 0-25.1Zm2.66 25.11v-1.93l6.15-6.16a1.33 1.33 0 0 0-1.88-1.88l-4.27 4.26v-4.82l3.43-3.44a1.33 1.33 0 1 0-1.88-1.9l-1.55 1.55V4c15.92 16.9 5.4 24.12 0 25.2Z" />
  </IconBase>
);
